export const ACTIONS = {
    SET_MANUFACTURERS: "SET_MANUFACTURERS",
    SET_MODELS: "SET_MODELS",
    SET_MODEL_TYPES: "SET_MODEL_TYPES",
    SET_DECK_SIZES: "SET_DECK_SIZES",
    SET_CONFIGURATIONS: "SET_CONFIGURATIONS",
    SET_OEM_BAGGERS: "SET_OEM_BAGGERS",
    SET_YEARS: "SET_YEARS",
    SET_MANUFACTURER: "SET_MANUFACTURER",
    SET_MODEL: "SET_MODEL",
    SET_MODEL_TYPE: "SET_MODEL_TYPE",
    SET_DECK_SIZE: "SET_DECK_SIZE",
    SET_CONFIGURATION: "SET_CONFIGURATION",
    SET_OEM_BAGGER: "SET_OEM_BAGGER",
    SET_YEAR: "SET_YEAR",
    SET_PRODUCT_DETAILS: "SET_PRODUCT_DETAILS",
    RESET: 'RESET',
}

export const initialState = {
    manufacturers: [],
    models: [],
    modelTypes: [],
    deckSizes: [],
    unitConfigurations: [],
    baggers: [],
    years: [],
    category: 'Commercial Mower',
    manufacturer: '',
    model: '',
    modelType: '',
    deckSize: '',
    unitConfiguration: '',
    bagger: '',
    year: '',
    productDetails: null,
    isProductDetailsLoading: false,
    isPurchaseDetailsLoading: false,
}

export function reducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case ACTIONS.SET_MANUFACTURERS:
            return {...state, manufacturers: payload };
        case ACTIONS.SET_MODELS:
            return {...state, models: payload };
        case ACTIONS.SET_MODEL_TYPES:
            return {...state, modelTypes: payload };
        case ACTIONS.SET_DECK_SIZES:
            return {...state, deckSizes: payload };
        case ACTIONS.SET_CONFIGURATIONS:
            return {...state, unitConfigurations: payload };
        case ACTIONS.SET_OEM_BAGGERS:
            return {...state, baggers: payload };
        case ACTIONS.SET_YEARS:
            return {...state, years: payload };
        case ACTIONS.SET_MANUFACTURER:
            return getStateWithDownstreamFieldsDeleted(state, "manufacturer", payload);
        case ACTIONS.SET_MODEL:
            return getStateWithDownstreamFieldsDeleted(state, "model", payload);
        case ACTIONS.SET_MODEL_TYPE:
            return getStateWithDownstreamFieldsDeleted(state, "modelType", payload);
        case ACTIONS.SET_DECK_SIZE:
            return getStateWithDownstreamFieldsDeleted(state, "deckSize", payload);
        case ACTIONS.SET_CONFIGURATION:
            return getStateWithDownstreamFieldsDeleted(state, "unitConfiguration", payload);
        case ACTIONS.SET_OEM_BAGGER:
            return getStateWithDownstreamFieldsDeleted(state, "bagger", payload);
        case ACTIONS.SET_YEAR:
            return getStateWithDownstreamFieldsDeleted(state, "year", payload);
        case ACTIONS.SET_PRODUCT_DETAILS:
            return {...state, productDetails: payload };
        case ACTIONS.SET_PRODUCT_DETAILS_LOADING:
            return {...state, isProductDetailsLoading: payload };
        case ACTIONS.SET_PURCHASE_DETAILS_LOADING:
            return {...state, isPurchaseDetailsLoading: payload };
        case ACTIONS.RESET:
            return initialState;
        default:
            console.log(`Action "${type}" does not exist.`, {payload})
            throw new Error(`Please provide a valid action.  "${type}" does not exist.`);
    }
}

const fieldOrder = [
    "manufacturer",
    "model",
    "modelType",
    "deckSize",
    "unitConfiguration",
    "bagger",
    "year",
    "productDetails",
];

const fieldCollection = {
    manufacturer: "manufacturers",
    model: "models",
    modelType: "modelTypes",
    deckSize: "deckSizes",
    unitConfiguration: "unitConfigurations",
    bagger: "baggers",
    year: "years",
};

function getStateWithDownstreamFieldsDeleted(state, basis, payload) {
    // find index of basis
    const index = fieldOrder.indexOf(basis);

    // create a new state with all fields downstream of the basis removed
    // also remove the collections asociated with the fields downstream of the basis
    const newState = {...state, [basis]: payload};
    const fieldsToDelete = fieldOrder.slice(index + 1);
    fieldsToDelete.forEach((field) => {
        newState[field] = initialState[field];
        newState[fieldCollection[field]] = initialState[fieldCollection[field]];
    });
    return newState;
}